var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "account-register-check-email" },
    [
      _c(
        "el-form",
        {
          ref: "registerForm",
          staticClass: "register-form",
          attrs: {
            model: _vm.registerForm,
            rules: _vm.registerRules,
            "label-position": "left",
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isSpecialTipCountry,
                  expression: "!isSpecialTipCountry",
                },
              ],
            },
            [
              _c(
                "el-form-item",
                {
                  ref: "emailFormItem",
                  attrs: { prop: "email" },
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function () {
                        return [_c("i", { staticClass: "icomoon-common_user" })]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("email-input", {
                    model: {
                      value: _vm.registerForm.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.registerForm, "email", $$v)
                      },
                      expression: "registerForm.email",
                    },
                  }),
                ],
                1
              ),
              _vm.hideEmail
                ? _c(
                    "el-form-item",
                    {
                      ref: "verifyCodeFormItem",
                      attrs: { prop: "verifyCode" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _c("i", { staticClass: "icomoon-common_lock" }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        4131992531
                      ),
                    },
                    [
                      _c("el-input", {
                        directives: [
                          { name: "input-limit", rawName: "v-input-limit" },
                        ],
                        staticClass: "login-code-input",
                        attrs: {
                          placeholder: _vm.$t("enter_img_verify_code"),
                          "data-input-type": "alphanumeric",
                          maxlength: 4,
                        },
                        nativeOn: {
                          keypress: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.onGetEmailCode.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.registerForm.verifyCode,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.registerForm,
                              "verifyCode",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "registerForm.verifyCode",
                        },
                      }),
                      _c("img", {
                        staticClass: "login-code-pic",
                        attrs: {
                          src: _vm.verifyImg,
                          alt: "",
                          crossorigin: "anonymous",
                        },
                        on: { click: _vm.changeCode },
                      }),
                      _vm.verifyErrorTxt
                        ? _c(
                            "div",
                            {
                              staticClass: "el-form-item__error my-false-item",
                            },
                            [_vm._v(_vm._s(_vm.verifyErrorTxt))]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.hideEmail
                ? _c(
                    "el-form-item",
                    {
                      ref: "validateCodeFormItem",
                      attrs: { prop: "validateCode" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _c("i", { staticClass: "icomoon-common_lock" }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        4131992531
                      ),
                    },
                    [
                      _c("el-input", {
                        directives: [
                          { name: "input-limit", rawName: "v-input-limit" },
                        ],
                        staticClass: "code-input",
                        attrs: {
                          maxlength: 6,
                          placeholder: _vm.$t("enter_verify_code"),
                          tips: _vm.$t("v_code"),
                          "data-input-type": "ten",
                        },
                        nativeOn: {
                          keypress: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.onRegister.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.registerForm.validateCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.registerForm, "validateCode", $$v)
                          },
                          expression: "registerForm.validateCode",
                        },
                      }),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.sendCodeBtnLoading,
                              expression: "sendCodeBtnLoading",
                            },
                          ],
                          staticClass: "code-button",
                          attrs: {
                            disabled: _vm.isSendDisabled,
                            type: "link",
                            "max-width": 135,
                          },
                          on: { click: _vm.sendCode },
                        },
                        [
                          _c("span", [_vm._v(_vm._s(_vm.$t(_vm.getCodeText)))]),
                          _vm.isSendDisabled
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.countdownValue > 0
                                      ? `(${_vm.countdownValue}s)`
                                      : ""
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.hideEmail
                ? _c(
                    "el-button",
                    {
                      staticStyle: { "max-width": "342px" },
                      attrs: { title: _vm.$t("no_email_code"), type: "link" },
                      on: {
                        click: function ($event) {
                          return _vm.showTips(0)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("no_email_code")) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      !_vm.isSpecialTipCountry
        ? [
            _vm.hideEmail
              ? _c(
                  "el-button",
                  {
                    staticClass: "entry-button",
                    attrs: { type: "primary", title: _vm.$t("get_code") },
                    on: { click: _vm.onGetEmailCode },
                  },
                  [_vm._v("\n      " + _vm._s(_vm.$t("get_code")) + "\n    ")]
                )
              : _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.btnLoading,
                        expression: "btnLoading",
                      },
                    ],
                    staticClass: "entry-button",
                    attrs: {
                      type: "primary",
                      disabled: _vm.hideEmail,
                      title: _vm.$t("btn_check_email"),
                    },
                    on: { click: _vm.onRegister },
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.$t("btn_check_email")) + "\n    "
                    ),
                  ]
                ),
          ]
        : _c("div", { staticClass: "special-country" }, [
            _c("i", { staticClass: "icomoon-common_alert_hint_sm" }),
            _c(
              "span",
              {
                staticClass: "text",
                attrs: { title: _vm.$t("not_support_in_your_region") },
              },
              [_vm._v(_vm._s(_vm.$t("not_support_in_your_region")))]
            ),
          ]),
      _c("register-tips", {
        ref: "RegisterTips",
        attrs: {
          type: 0,
          "is-special-tip-country": false,
          email: _vm.registerForm.email,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }